import { createContext, useContext } from 'react';
import type { PlanUpsellIntent } from './types';

export type UpsellContextValue = {
  intent: PlanUpsellIntent | null;
  openUpsell: (intent: PlanUpsellIntent) => void;
  closeUpsell: () => void;
};

export const UpsellContext = createContext<UpsellContextValue | undefined>(undefined);

export function useUpsell(): UpsellContextValue {
  const ctx = useContext(UpsellContext);
  if (!ctx) {
    throw new Error('useUpsell must be used within UpsellProvider');
  }
  return ctx;
}

/** Optional bridge for reusable controls that can render outside the Portal shell. */
export function useOptionalUpsell(): UpsellContextValue | null {
  return useContext(UpsellContext) ?? null;
}
